module.exports = __webpack_public_path__ + "img/dmp1.d8c96e2e.png";